import React from "react";
import { KPIOverviewTileModel } from "../../types";
import {
  CHANGE_TONE_STYLES,
  STATUS_STYLES,
} from "../../utils/kpiOverviewStatus";

interface KPIOverviewCompactTileProps {
  tile: KPIOverviewTileModel;
}

const NO_VALUE = "-";

const KPIOverviewCompactTile: React.FC<KPIOverviewCompactTileProps> = ({
  tile,
}) => {
  const style = STATUS_STYLES[tile.status];

  return (
    <div
      aria-label={`${tile.name} ${tile.valueLabel ?? "no value"}, ${style.label}`}
      className={`flex min-w-0 flex-col gap-0.5 rounded-md border border-t-2 border-gray-100 px-2 py-1.5 dark:border-slate-700/50 ${style.topBorder}`}
      data-testid="kpi-overview-compact-tile"
      role="group"
    >
      <span className="truncate text-xs text-gray-500 dark:text-gray-400">
        {tile.shortLabel}
      </span>
      <span
        className={`font-mono text-sm font-normal tabular-nums ${style.value}`}
      >
        {tile.valueLabel ?? NO_VALUE}
      </span>
      <span
        className={`h-4 truncate font-mono text-xs tabular-nums ${CHANGE_TONE_STYLES[tile.changeTone]}`}
      >
        {tile.changeLabel}
      </span>
    </div>
  );
};

export default KPIOverviewCompactTile;
